import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import graphqlPropTypes from '@prisjakt/graphql-proptypes';
import { AppContext } from '@prisjakt/ui-app-context';
import Breadcrumb from '@prisjakt/ui-breadcrumb';

import * as S from './styles';
import Page from './components/page';
import PageContent from '../../components/page-content';
import infoPagesQuery from './query.graphql';
import { InfoPageQuery } from '../../types';

const InfoPages = props => {
  const { t } = useContext(AppContext);
  const { pageContent } = props.data;

  if (!pageContent) {
    return null;
  }
  return (
    <PageContent>
      <Breadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={[
          {
            id: '1',
            name: pageContent.title,
            pathName: pageContent.pathName,
          },
        ]}
      />
      <S.Section>
        {pageContent.id === 6 && (
          <S.PrivacyLink>
            <Link to="/privacy-settings">
              {t('tracking-settings', 'link.privacy-settings')}
            </Link>
          </S.PrivacyLink>
        )}
        {pageContent && <Page {...pageContent} />}
      </S.Section>
    </PageContent>
  );
};

InfoPages.variables = ({ id }) => ({
  id: parseInt(id, 10),
});

InfoPages.graphQL = infoPagesQuery;

InfoPages.loadOrder = [{}];

InfoPages.propTypes = {
  data: PropTypes.shape({
    pageContent: graphqlPropTypes(InfoPageQuery),
  }),
};

InfoPages.defaultProps = {
  data: {
    pageContent: undefined,
  },
};

export default InfoPages;
